"use client";

import { useMemo } from "react";
import Uri from "../utils/uri/Uri";
import generateApiRouter from "../../account/helpers/router/api";
import { ApiRouterContext } from "../hooks/useApiRouter";

/**
 * @typedef {object} Props
 * @prop {string} accountHostname
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function ApiRouterProvider({ accountHostname, children }) {
  const accountBaseUri = useMemo(
    function () {
      const uri = Uri.fromString(`https://${accountHostname}`);

      // Si une base path est définie, on l'ajoute à l'URL de base
      if (process.env.NEXT_PUBLIC_BASE_PATH) {
        uri.setPath(process.env.NEXT_PUBLIC_BASE_PATH);
      }

      return uri;
    },
    [accountHostname],
  );

  const value = useMemo(() => {
    /** @type {import("../hooks/useApiRouter").ApiRouterContextValue} */
    const value = {
      apiRouter: generateApiRouter({
        baseUrl: accountBaseUri,
        useProxy: true,
      }),
    };
    return value;
  }, [accountBaseUri]);

  return (
    <ApiRouterContext.Provider value={value}>
      {children}
    </ApiRouterContext.Provider>
  );
}
